import React, { Component } from "react";

class ReportTwo extends Component {
  render() {
    return (
      <>
        <div className={this.props.workingModal ? "" : "hide"}>
          <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
            CARGANDO INFORMACIÓN
          </div>
        </div>

        <div className={this.props.workingModal ? "hide" : ""}>
          <fieldset className="col-md-12">
            <legend>DATOS</legend>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="no_factura_exportacion">
                    No. de factura de Exportación:{" "}
                    <span className="text-danger"> *</span>
                  </label>

                  <input
                    type="text"
                    name="no_factura_exportacion"
                    id="no_factura_exportacion"
                    onChange={this.props.handleRazonSocialChange}
                    // value={this.props.state.no_factura_exportacion}
                    className="form-control"
                    placeholder="Ingrese número de factura de exportación"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="no_factura_exportacion-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="no_certificado_exportacion">
                    No. de certificado de exportación:{" "}
                    <span className="text-danger"> *</span>
                  </label>

                  <input
                    type="text"
                    name="no_certificado_exportacion"
                    id="no_certificado_exportacion"
                    onChange={this.props.handleRazonSocialChange}
                    // value={this.props.state.no_certificado_exportacion}
                    className="form-control"
                    placeholder="Ingrese número de certificado de exportación"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="no_certificado_exportacion-error"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="aduana">
                    Nombre de la aduana en que exportó la sustancia o producto:{" "}
                    <span className="text-danger"> *</span>
                  </label>

                  <input
                    type="text"
                    name="aduana"
                    id="aduana"
                    onChange={this.props.handleRazonSocialChange}
                    // value={this.props.state.aduana}
                    className="form-control"
                    placeholder="Ingrese nombre de la aduana"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="aduana-error"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="fecha_ingreso_aduana">
                    Fecha de ingreso en aduana:{" "}
                    <span className="text-danger"> *</span>
                  </label>

                  <input
                    type="date"
                    name="fecha_ingreso_aduana"
                    id="fecha_ingreso_aduana"
                    onChange={this.props.handleRazonSocialChange}
                    // value={this.props.state.aduana}
                    className="form-control"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="fecha_ingreso_aduana-error"
                  ></div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="fecha_exportador_aduana">
                    Fecha de egreso en bodega del establecimiento exportador:{" "}
                    <span className="text-danger"> *</span>
                  </label>

                  <input
                    type="date"
                    name="fecha_exportador_aduana"
                    id="fecha_exportador_aduana"
                    onChange={this.props.handleRazonSocialChange}
                    // value={this.props.state.aduana}
                    className="form-control"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="fecha_exportador_aduana-error"
                  ></div>
                </div>
              </div>
            </div>

            <hr />

            <button
              type="button"
              onClick={this.props.rejectedAll}
              className="btn btn-danger pull-right ml-3"
            >
              Regresar
            </button>

            <button type="submit" className="btn btn-success pull-right">
              Guardar
            </button>

            {/* </div> */}
          </fieldset>
        </div>
      </>
    );
  }
}

export default ReportTwo;
